module.exports = __webpack_public_path__ + "static/media/phone_feedback.f352dbf5.png";